module.exports = {"pathContext":{"name":"UpdateStockTransferRequestItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"productId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"requestedQuantity","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-update-stock-transfer-request-item-input.json
// module id = 1595
// module chunks = 274346788566796